import { noop } from 'lodash';
import throttle from 'lodash/throttle';

import type { MixpanelEvents } from '../lib/logger/analytics';

type UserEventListener = (event: MixpanelEvents) => void;
let _listener: UserEventListener = noop;

export const setUserEventListener = (listener: UserEventListener) => {
  _listener = listener;
};

const _throttledEmit = throttle(
  (event: MixpanelEvents) => _listener(event),
  60000,
  { leading: true, trailing: false }
);

export const emitMixpanelUserEvent = (event: MixpanelEvents) => {
  _throttledEmit(event);
};
